<script>
import {VueEditor} from 'vue2-editor'

export default {
    components: {
        VueEditor,
    },

    props: {
        label: {
            type: String,
            default: 'auto',
        },
        name: {
            type: String,
        },
        prefill: {
            type: [String, Number],
            default: null,
        },
        localize: {
            type: String,
            default: null,
        },
        localeId: {
            type: Number,
            default: -1,
        },
        size: {
            type: Number,
            default: 3,
        },
        sync: {
            type: String,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            value: '',
            editorOptions: {
                modules: {
                    toolbar: [
                        [{header: [2, 3, false]}],
                        ['bold', 'italic', 'underline'],
                        [{list: 'ordered'}, {list: 'bullet'}],
                        ['link'],
                        ['clean']
                    ]
                },
                formats: ['header', 'bold', 'italic', 'underline', 'list', 'link']
            }
        }
    },

    watch: {
        value(value) {
            this.$emit('sync', value)
            this.$children[0].updateValue(value)
        },
        prefill(value) {
            this.value = value
        },
    },

    mounted() {
        this.value = this.prefill
    },

    methods: {
        appendTo(content) {
            if (this.name) {
                if (this.localize) {
                    let localeKey = this.localize + 'I18ns'

                    if (!(localeKey in content)) {
                        content[localeKey] = [{}]
                        if (this.localeId > 0) {
                            content[localeKey][0]['Id'] = this.localeId
                        }
                        content[localeKey][0]['Locale'] = this.$root.settings('locale')
                    }

                    content[localeKey][0][this.name] = this.$children[0].value
                } else {
                    content[this.name] = this.$children[0].value
                }
            } else {
                content['__' + this.label] = this.$children[0].value
            }
            return content
        },
    },
}
</script>

<template>
    <bg-form-wrapper :label="label" :name="name" :size="size" :prefill="prefill">
        <div class="input-container">
            <slot/>
            <vue-editor v-model="value" :editorOptions="editorOptions"/>
        </div>
    </bg-form-wrapper>
</template>
